<div class="va-order-item-list">
  <ng-container class="product-list" *ngIf="storeItems$ | async as storeItems; else loading">
    <ng-container *ngFor="let item of storeItems">
      <div class="non-printable">
        <store-order-item-compact [item]="item" [showPricing]="showPricing" />
      </div>
      <div class="print">
        <h3>{{ item.name }}</h3>
        <div [ngClass]="{ 'non-printable': !showPricing }">
          <store-pricing [pricing]="item.pricing" [highlightPrice]="false" [showAllPrices]="true" />
          <div
            class="print-store-amount"
            *ngIf="
              item.pricing.totalStorePriceInDollars &&
              item.pricing.totalPriceInDollars &&
              item.pricing.totalStorePriceInDollars > item.pricing.totalPriceInDollars
            "
          >
            <billing-ui-simple-price-display
              [price]="(item.pricing.totalStorePriceInDollars || 0) * 100"
              [currencyCode]="item.pricing.currency"
              [frequency]="Frequency.ONE_TIME"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <div class="stencil-shimmer"></div>
  </ng-template>
</div>
